export const DEFAULT_DISPLAY_NAME = "NewPlayer";
export const DEFAULT_SHORT_BIO = "just a new gamer starting my gaming journey";
export const DEFAULT_ABOUT_ME = "Hey there! I just joined and I'm excited to start tracking the games I love.";